import React from "react";
import { NavLink } from "react-router-dom";
import { WordRestrictions } from "../../../models/extension/WordExtention";
import { RowFieldProps } from "./RowField.models";
import './RowField.scss';

export default class RowField extends React.PureComponent<RowFieldProps, {}> {

    render(): React.ReactNode {
        let { details, children, actionButton, wordRestrictionLeghnt, wordSubTitleRestrictionLeghnt } = this.props;
        let boxStyle = { backgroundImage: `url(${details.imageSource})` };

        return <>
            <div className="col-12 row-field-area notspace margin-top " style={{ height: "12vh" }}>
                <div className="tk-inline card-boundel">
                    <div className="col-2 notspace">
                        <div className="points" style={boxStyle}>
                            {children}
                        </div>
                    </div>
                    <div className="col-6 notspace" style={{ textAlign: "right", marginRight: "20px" }}>
                        <div className="pd-detail">
                            <div className="course-title tk-tooltip">
                                <label onClick={e => e.stopPropagation()}>
                                    {details.title !== null && details.title !== undefined ? WordRestrictions(details.title, wordRestrictionLeghnt ?? 12) : ""}
                                </label>
                                <label className="tk-tooltiptext buttom">{details.title}</label>
                            </div>
                            <div className="course-subtitle tk-tooltip">
                                <label>
                                    {details.subTitle !== null && details.subTitle !== undefined ? WordRestrictions(details.subTitle, wordSubTitleRestrictionLeghnt ?? 20) : ""}
                                    <label className="tk-tooltiptext buttom">{details.subTitle}</label>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="col-3 notspace" style={{ textAlign: "right", marginRight: "20px" }}>
                        {actionButton !== undefined && details.showButton === true ?
                            <>
                                {actionButton.onClick ?
                                    <button onClick={() => actionButton?.onClick()} className="button-box" style={details.buttonStyle}>{details.buttonText}</button> :
                                    <NavLink to={actionButton?.redirct ? actionButton?.redirct : ''}>
                                        <button className="button-box" style={details.buttonStyle}>{details.buttonText}</button>
                                    </NavLink>
                                }
                            </> :
                            details.showButton === true ? <> <label className="button-box" style={details.buttonStyle}>{details.buttonText}</label></> : <></>
                        }
                    </div>
                </div>
            </div>
        </>
    }
}